import React from "react";
import "./footer.css";
function Footer() {
  return <div className="footer"></div>;
}

export default Footer;